import React, { useState, useEffect, useCallback } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
//Component
import { Modal } from "../../../stories/modal";
import { ReactTable } from "../../../stories/react-table";
import { API_URL } from "../../../utils/api-utils";
//Function
import { getUserDataDownloadTemplateColumns } from "../columns/user-data-management";
import * as alertDialog from "../../../utils/alert";
import * as api from "../api";
import { DownloadTemplate } from "../../config-master-template/api";
import { GetUser } from "../../../utils/sessions";

function UserDataDownloadTemplateModal(props) {
  const { open } = props;
  const { ...otherprops } = props;

  const [dataList, setDatalist] = useState([]);

  const method = useForm();
  const fetch = useCallback(async () => {
    const param = {
      USER_ID: GetUser(),
      MODE: "Refresh",
    };
    const res = await api.GetListDownloadTemplate(param);
    setDatalist(res ?? []);
  }, []);

  useEffect(() => {
    if (!open) return;
    fetch();
  }, [fetch, open]);

  const onDownloadTemplate = async (TEMPLATE_ID) => {
    let param = { TEMPLATE_ID: TEMPLATE_ID };
    let res = await DownloadTemplate(param);
    if (res?.FileName) {
      const url = `${API_URL.Loader}/` + res?.FileName;
      const fileName = `template-file-${TEMPLATE_ID}.csv`;

      // Create an invisible link element
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      // Append link to body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      document.body.removeChild(link);
    } else {
      alertDialog.ErrorDialog("Error : File Not Found");
    }
  };

  return (
    <Modal
      {...otherprops}
      hiddenSave={true}
      title="Download Template List"
      maxWidth="sm"
    >
      <FormProvider {...method}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <ReactTable
                otherprops
                keyField="TEMPLATE_ID"
                data={dataList}
                columns={getUserDataDownloadTemplateColumns(onDownloadTemplate)}
                showSearch={false}
              />
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  );
}
export default UserDataDownloadTemplateModal;
